import App from './App'
import DeviceManagement from './DeviceManagement'
import FeatureAccess from './FeatureAccess'
import Fleet from './Fleet'
import Navbar from './Navbar'
import Notifications from './Notifications'
import Overview from './Overview'
import PortCall from './PortCall'
import Ports from './Ports'
import Settings from './Settings'
import Ship from './Ship'
import User from './User'
import Vessel from './Vessel'

export const selectors = {
  ...App.selectors,
  ...DeviceManagement.selectors,
  ...FeatureAccess.selectors,
  ...Fleet.selectors,
  ...Navbar.selectors,
  ...Notifications.selectors,
  ...Overview.selectors,
  ...PortCall.selectors,
  ...Ports.selectors,
  ...Settings.selectors,
  ...Ship.selectors,
  ...User.selectors,
  ...Vessel.selectors,
}

export const sagas = {
  ...App.sagas,
  ...DeviceManagement.sagas,
  ...FeatureAccess.sagas,
  ...Fleet.sagas,
  ...Notifications.sagas,
  ...Overview.sagas,
  ...PortCall.sagas,
  ...Ports.sagas,
  ...Settings.sagas,
  ...Ship.sagas,
  ...User.sagas,
  ...Vessel.sagas,
}

export const actions = {
  ...App.actions,
  ...DeviceManagement.actions,
  ...FeatureAccess.actions,
  ...Fleet.actions,
  ...Navbar.actions,
  ...Notifications.actions,
  ...Overview.actions,
  ...PortCall.actions,
  ...Ports.actions,
  ...Settings.actions,
  ...Ship.actions,
  ...User.actions,
  ...Vessel.actions,
}

export const reducers = {
  app: App.reducer,
  deviceManagement: DeviceManagement.reducer,
  featureAccess: FeatureAccess.reducer,
  fleet: Fleet.reducer,
  navbar: Navbar.reducer,
  notifications: Notifications.reducer,
  overview: Overview.reducer,
  portCall: PortCall.reducer,
  ports: Ports.reducer,
  settings: Settings.reducer,
  ship: Ship.reducer,
  user: User.reducer,
  vessel: Vessel.reducer,
}
